import { __awaiter, __decorate, __generator, __metadata } from "tslib";
import { genHaloConfig, isAxiosError } from "@smartsheet/http-client";
import { client, buildSynchronousSettingsRequest } from "../http";
import { injectable } from "inversify";
import "reflect-metadata";
import { createDeferred } from "../utils/Deferred";
var SettingsStateService = /** @class */ (function () {
    function SettingsStateService() {
        var _this = this;
        this.userSettings = new Map();
        this.shortCircuitSynchronousRetries = false;
        this.synchronousRequestTokens = 6;
        this.getUserSettingValue = function (settingName) {
            _this.refreshSettingsIfNotLoaded();
            return _this.getUserSetting(settingName);
        };
        this.writeUserPreferenceSetting = function (settingName, data) { return __awaiter(_this, void 0, void 0, function () {
            var err_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, client.put("/2.0/settings/values/users/me/" + settingName, data, genHaloConfig())];
                    case 1:
                        _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _c.sent();
                        if (isAxiosError(err_1)) {
                            if ((_a = err_1.response) === null || _a === void 0 ? void 0 : _a.data) {
                                throw new Error("Axios Error: " + JSON.stringify((_b = err_1.response) === null || _b === void 0 ? void 0 : _b.data));
                            }
                        }
                        throw err_1;
                    case 3: return [2 /*return*/, this.setUserSettings()];
                }
            });
        }); };
        this.refreshSettingsIfNotLoaded = function () {
            if (_this.userSettings.size === 0) {
                if (_this.synchronousRequestTokens === 0 &&
                    _this.synchronousSettingsLastRequestAttemptTimestamp &&
                    Date.now() -
                        _this.synchronousSettingsLastRequestAttemptTimestamp >
                        60000) {
                    _this.synchronousRequestTokens = 3;
                }
                for (var retryCount = 0; retryCount < 2; retryCount++) {
                    try {
                        if (_this.shortCircuitSynchronousRetries ||
                            _this.synchronousRequestTokens === 0) {
                            break;
                        }
                        var xhr = buildSynchronousSettingsRequest("/2.0/settings/values/users/me");
                        xhr.send();
                        _this.synchronousSettingsLastRequestAttemptTimestamp =
                            Date.now();
                        if (xhr.status === 200) {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                            var userSettings = JSON.parse(xhr.responseText);
                            for (var _i = 0, _a = userSettings.results; _i < _a.length; _i++) {
                                var userSetting = _a[_i];
                                _this.userSettings.set(userSetting.name, userSetting);
                            }
                            _this.isLoaded.resolve(true);
                            _this.settingsLoadedTimestamp = Date.now();
                            break; // Break the loop on successful response
                        }
                        else if (xhr.status === 413 ||
                            xhr.status === 503 ||
                            xhr.status === 401) {
                            _this.shortCircuitSynchronousRetries = true;
                            throw new Error("HTTP error! Status: " + xhr.status + ". Aborting further retries.");
                        }
                        else {
                            throw new Error("HTTP error! Status: " + xhr.status);
                        }
                    }
                    catch (error) {
                        console.error("Error fetching data (attempt " + (retryCount + 1) + "):", error);
                    }
                    finally {
                        if (_this.synchronousRequestTokens > 0) {
                            _this.synchronousRequestTokens--;
                        }
                    }
                }
            }
        };
        this.getUserSetting = function (settingName) {
            if (_this.userSettings.has(settingName)) {
                return _this.userSettings.get(settingName);
            }
            else {
                var userSetting = {
                    name: null,
                    scope: null,
                    owner: null,
                    valueString: null,
                    valueLong: null,
                    valueDouble: null,
                    valueBoolean: null,
                    valueDateTime: null,
                    insertDateTime: null,
                    modifyDateTime: null,
                    insertByUserID: null,
                    modifyByUserID: null,
                    lineage: null
                };
                return userSetting;
            }
        };
        this.setUserSettings = function () { return __awaiter(_this, void 0, void 0, function () {
            var userSettings, _i, _a, userSetting, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, client.get("/2.0/settings/values/users/me", genHaloConfig())];
                    case 1:
                        userSettings = _b.sent();
                        for (_i = 0, _a = userSettings.data.results; _i < _a.length; _i++) {
                            userSetting = _a[_i];
                            this.userSettings.set(userSetting.name, userSetting);
                        }
                        this.isLoaded.resolve(true);
                        this.settingsLoadedTimestamp = Date.now();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        // TODO implement logging service here
                        console.log(e_1);
                        this.isLoaded.resolve(false);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.isEAPSettingEnabled = function (settingName) {
            var userSetting = _this.userSettings.get(settingName);
            if ((userSetting === null || userSetting === void 0 ? void 0 : userSetting.valueLong) === 2) {
                return true;
            }
            else
                return ((userSetting === null || userSetting === void 0 ? void 0 : userSetting.valueLong) === 1 &&
                    userSetting.valueDouble === 1.0 &&
                    userSetting.valueBoolean);
        };
        this.isLoaded = createDeferred();
        void this.setUserSettings();
    }
    SettingsStateService = __decorate([
        injectable(),
        __metadata("design:paramtypes", [])
    ], SettingsStateService);
    return SettingsStateService;
}());
export { SettingsStateService };
//# sourceMappingURL=SettingsStateService.js.map